// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__EyxIv","rootSmall":"AddTileButton_rootSmall__3sBFj"};